export const defaultConfig = {
  descriptionWordLimit: 15,
  titleCharacterLimit: 70,
  descriptionLineLimit: 3,
  titleLineLimit: 2,
  autoplayInterval: 3000,
};
